/*global google*/
import React from 'react';
import Modal from 'react-modal';
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import HeatmapLayer from '../MapFeatures/HeatmapLayer';

export default function MapRouteModal(props) {
  return (
    <Modal
      className="Modal__Bootstrap modal-dialog modal-lg"
      closeTimeoutMS={150}
      isOpen={props.modalMapRouteIsOpen}
      onRequestClose={props.closeMapRouteModal}
      ariaHideApp={false}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Gelopen ronde bekijken</h4>
          <button type="button" className="close" onClick={props.closeMapRouteModal}>
            <span aria-hidden="true">&times;</span>
            <span className="sr-only">Annuleren</span>
          </button>
        </div>
        <div className="modal-body">
          {createMap(props)}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={props.closeMapRouteModal}>Sluiten</button>
        </div>
      </div>
    </Modal>
  )

  function createMap(props) {

    if (props.lastSelectedRouteHeatmapPoints.length <= 0) {
      return 'Geen heatmap data gevonden.';
    }

    const latPos = props.lastSelectedRouteHeatmapPoints[0].latitude;
    const longPos = props.lastSelectedRouteHeatmapPoints[0].longitude;

    return (<APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}><Map style={{ height: '400px', width: '100%' }} mapId={"MapRouteModal"} defaultZoom={15} clickableIcons={false} defaultCenter={{ lat: latPos, lng: longPos }}>
      <HeatmapLayer heatmapPoints={props.lastSelectedRouteHeatmapPoints} radius={10} />
    </Map></APIProvider>);
  }
}